;(function ($, _, window) {

    const MAIN_CONTAINER_ID = "business_listings_map_container";
    const MAP_CONTAINER_ID = "map_holder";
    const TAX_CONTAINER_ID = "taxonomy_holder";
    const TAX_TOGGLE_ID = "taxonomy_mobile_control";
    const NEWPARK_CENTER_COORDS = {lat: 40.7217299, lng: -111.5385515};

    const business_data = (window.business_listings && window.business_listings.listings_by_category)
        ? window.business_listings.listings_by_category
        : {};

    let current_tax_slug = false;
    let current_markers = [];
    let open_infowindows = [];
    let map = false;

    // MAIN INIT ROUTINE
    function business_listing_map_init() {

        map = new google.maps.Map(
            document.getElementById(MAP_CONTAINER_ID), {zoom: 16, center: NEWPARK_CENTER_COORDS});

        renderState();

        $("#" + MAIN_CONTAINER_ID).on('click', '.business-type', function (ev) {
            current_tax_slug = $(this).data('slug');
            renderState();
        });

        $("#" + MAIN_CONTAINER_ID).on('click', '.reset-category', function (ev) {
            current_tax_slug = '';
            renderState();
        });

        $("#" + MAIN_CONTAINER_ID).on('click', '.category-contents h1', function (ev) {
            current_tax_slug = '';
            renderState();
        });

        $("#" + MAIN_CONTAINER_ID).on('click', '.business-listing', function (ev) {
            const title = $(this).text();
            const marker = _.findWhere(current_markers, {'title': title});
            google.maps.event.trigger(marker, 'click');
        });

        $("#" + MAIN_CONTAINER_ID).on('click', "#" + TAX_TOGGLE_ID, function (ev) {
            $(".taxonomy-holder").toggleClass('moved-offscreen');
        });

    }

    function renderState() {
        renderTaxMenu();
        setupMarkers();
    }

    function fitMapBounds() {
        var bounds = new google.maps.LatLngBounds();
        for (var i = 0; i < current_markers.length; i++) {
            bounds.extend(current_markers[i].getPosition());
        }

        map.fitBounds(bounds);
    }

    function renderTaxMenu() {

        // draw the full menu if there is none selected::

        if ('' == current_tax_slug) {
            let items = _.reduce(business_data, (memo, el) => {
                className = (current_tax_slug == el.slug) ? 'selected' : 'not-selected'
                return memo + `<li class="business-type ${className} color-${el.color}  top-level" data-slug="${el.slug}"><span class="dot"></span>${el.name}</li>`;
            }, '');
            document.getElementById(TAX_CONTAINER_ID).innerHTML = `<ul>${items}</ul>`;
            return true;
        }

        const name = `<h1 class="selected"><span class="arrow"></span>${business_data[current_tax_slug].name}</h1>`;
        const button = "<button class='reset-category'>Back to Categories</button>";
        const color = business_data[current_tax_slug].color;
        let items = _.reduce(business_data[current_tax_slug].posts, (memo, el) => {
            return memo + `<li class="business-listing"><span class="dot"></span>${el.post_title}</li>`;
        }, '');

        document.getElementById(TAX_CONTAINER_ID).innerHTML = `<div class="category-contents color-${color}">${name}<ul>${items}</ul>${button}</div>`;

    }

    function setupMarkers() {

        for (var i = 0; i < current_markers.length; i++) {
            current_markers[i].setMap(null);
        }
        current_markers = [];
        open_infowindows = [];

        if (!current_tax_slug) return;

        _.each(business_data[current_tax_slug].posts, function (marker_data) {
            const meta = marker_data.map_data;
            const markerLatLng = new google.maps.LatLng(meta.lat, meta.lng);

            const color = (null != business_data[current_tax_slug].color) ? business_data[current_tax_slug].color : 'gray';

            const marker = new google.maps.Marker({
                position: markerLatLng,
                title: marker_data.post_title,
                icon: {
                    url: `/wp-content/themes/newpark/assets/images/map_locator_${color}.svg`,
                    scaledSize: new google.maps.Size(40, 40)
                }
            });

            const hours = (!marker_data.map_data.opening_hours) ? '' : _.reduce(marker_data.map_data.opening_hours.weekday_text,
                (memo, el) => {
                    const split = el.split(':');
                    const day = split.shift();
                    const time = split.join(':');
                    return memo + `<li><span class="day">${day}</span><span class="time">${time}</span></li>`
                }
                , '');
            const hours_output = ('' === hours) ? hours : `<div><h2>HOURS</h2><ul>${hours}</ul></div>`;

            const address_explode = meta.address.split(',');

            const infowindow_content = `
                <article class="infowindow-content">
                    <h1>${marker_data.post_title}</h1>
                    <div class="base-info">
                        <div class="iw_logo_container">
                            <img src="${marker_data.logo_url}" alt="Business Logo" aria-hidden="true" class="iw_logo">
                        </div>
                        <div class="address">
                            ${address_explode[0]}<br/>
                            ${address_explode[1]}, ${address_explode[2]} ${address_explode[3]}<br/>
                        </div>       
                        <div class="phone">${meta.formatted_phone_number}</div>
                    </div>
                    <div class="hours-container">${hours_output}</div>
                    <div class="google-link-container"><a href="https://www.google.com/maps/place/?q=place_id:${meta.place_id}">Open In Google Maps</a></div>
                </article>
            `;

            var infowindow = new google.maps.InfoWindow({
                content: infowindow_content,
                pixelOffset: new google.maps.Size(50, 0)
            });

            marker.addListener('click', function () {
                for (var i = 0; i < open_infowindows.length; i++) {
                    open_infowindows[i].close();
                }
                infowindow.open(map, marker);
                if ($(document).width() < 1000) {
                    $(".taxonomy-holder").addClass('moved-offscreen');
                }
                open_infowindows.push(infowindow);
            });

            marker.setMap(map);
            current_markers.push(marker);
        });

        fitMapBounds();
    }

    window.business_listing_map_init = business_listing_map_init;

})(jQuery, _, window);